<div mdbModal #modal="mdbModal" class="modal fade parsingModal" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
     aria-hidden="true" [config]="{backdrop: 'static'}">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div *ngIf="isParsingPending">
        <h1>Please Hold.</h1>
        <p>
          The resume you uploaded is currently being analyzed.
          Upon completion, much or all of your information will appear in the remaining sections of this job application.
        </p>
      </div>
      <div *ngIf="hasParsingFailed">
        <h1>Parsing failed.</h1>
        <p>The resume you uploaded was unable to be parsed, therefore you must
          manually enter your information in the remaining sections of this application. Alternatively, you may re-apply
          and upload a new resume.</p>
          <button class="btn btn-primary" (click)="skipResumeParsing()" mdbWavesEffect>Skip Resume Parsing</button>
      </div>
    </div>
  </div>
</div>
